var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuCart = function SvgMenuCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "m1.429 14.142 1.272-7A2 2 0 0 1 4.67 5.5h8.662a2 2 0 0 1 1.968 1.642l1.272 7a2 2 0 0 1-1.967 2.358H3.396a2 2 0 0 1-1.967-2.358Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.4,
    d: "M6 4.5c.112-2.028 1.422-3 3-3s2.888.972 3 3"
  })));
};
export default SvgMenuCart;